import { Box, Grid } from "@mui/material";
import Button from "components/common/Button";
import Basictabs from "components/common/Tabs";
import Typography from "components/common/Typography";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { DISPLAY_TYPE } from "utils/CommonConstants";
import { setConfigTabSelected } from "../Dashboard.slice";
import { Config } from "./Config";

interface Props {
  type: any;
}

function Overview(props: Props) {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { type } = props;
  const configTabSelected = useAppSelector((state) => state.Dashboard.configTabSelected);

  const navigateUrl = () => {};
  const { themeBG = "dark", color, title, tabs = [], buttonVariant = "", buttons } = Config[type];
  const buttonText = buttons && buttons[configTabSelected[type]]?.label;
  const targetURL = (buttons && buttons[configTabSelected[type]]?.targetURL) || navigateUrl;
  const getSelectedTab = (val: number) => {
    dispatch(setConfigTabSelected({ type, val }));
  };
  const getScreenLayout = () => {
    return (
      <>
        <Grid
          container
          sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", minHeight: "43px" }}
        >
          <Grid item>
            <Typography color={themeBG === "light" ? tokens.Text.General.Secondary : ""} showBold>
              {title}
            </Typography>
          </Grid>
          {buttons && (
            <Grid item>
              <Button
                size="Small"
                variant={themeBG === "light" ? "outlined" : "secondaryWhite"}
                label={buttonText}
                onClick={() => targetURL(navigate)}
              ></Button>
            </Grid>
          )}
        </Grid>
        <Grid container>
          <Basictabs
            gap="16px"
            marginBottom={DISPLAY_TYPE.highlights === type ? "24px" : "32px"}
            labelVariant={"body2"}
            tabDetails={tabs}
            alignItems="left"
            backgroundColor={color}
            whiteVariant={themeBG === "dark"}
            defaultTab={configTabSelected[type]}
            selectedTab={getSelectedTab}
          ></Basictabs>
        </Grid>
      </>
    );
  };

  return (
    <Box
      sx={{
        background: color,
        color: themeBG === "light" ? tokens.Text.General.Secondary : tokens.Text.General.Inverse,
        borderRadius: "12px",
        height: themeBG === "light" ? "413px" : "480px",
        padding: "40px 24px 24px"
      }}
      width={themeBG === "light" ? "100%" : "auto"}
    >
      {getScreenLayout()}
    </Box>
  );
}

export default Overview;
